import axios from 'axios/dist/axios';


const defaultState = {
    scoringData: {},
    testTreeData: '',

    userDecision: {
        decisionItem1List: [],
        selectedDecisionItem1Code: null,

        decisionItem2List: [],
        selectedDecisionItem2Code: null,

        comment: ""
    },
    mustShowSendAssessmentPopup: false,
    mustShowPrintPdfPopup: false,
    assessmentSent: false,
    mustShowSummaryPopup: false,
    summaryAssessmentId: null,
    isAssessmentSealed: false,
    assessmentEndFinishData: null
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    scoringData:                      defaultState.scoringData,
    testTreeData:                     defaultState.testTreeData,

    userDecision: {
        decisionItem1List:            defaultState.userDecision.decisionItem1List,
        selectedDecisionItem1Code:    defaultState.userDecision.selectedDecisionItem1Code,

        decisionItem2List:            defaultState.userDecision.decisionItem2List,
        selectedDecisionItem2Code:    defaultState.userDecision.selectedDecisionItem2Code,

        comment:                      defaultState.userDecision.comment
    },
    mustShowSendAssessmentPopup:      defaultState.mustShowSendAssessmentPopup,
    mustShowPrintPdfPopup:            defaultState.mustShowPrintPdfPopup,
    assessmentSent:                   defaultState.assessmentSent,
    mustShowSummaryPopup:             defaultState.mustShowSummaryPopup,
    summaryAssessmentId:              defaultState.summaryAssessmentId,
    isAssessmentSealed:               defaultState.isAssessmentSealed,
    assessmentEndFinishData:          defaultState.assessmentEndFinishData,
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getScoringData:                 state => state.scoringData,
    getTestTreeData:                state => state.testTreeData,

    getUserDecision:                state => state.userDecision,

    getSelectedUserDecisionItem2Data(state) {
        if(state.userDecision && state.userDecision.decisionItem2List) {
            return state.userDecision.decisionItem2List.filter((crtItem) => {
                return (crtItem.code === state.userDecision.selectedDecisionItem2Code) ? true : false;
            })[0];
        }
    },

    getSelectedUserDecisionItem1Data(state) {
        if(state.userDecision && state.userDecision.decisionItem1List) {
            return state.userDecision.decisionItem1List.filter((crtItem) => {
                return (crtItem.code === state.userDecision.selectedDecisionItem1Code) ? true : false;
            })[0];
        }
    },
    getMustShowSendAssessmentPopup: state => state.mustShowSendAssessmentPopup,
    getMustShowPrintPdfPopup: state => state.mustShowPrintPdfPopup,
    getAssessmentSent: state => state.assessmentSent,
    getMustShowSummaryPopup: state => state.mustShowSummaryPopup,
    getSummaryAssessmentId: state => state.summaryAssessmentId,
    getIsAssessmentSealed: state => state.isAssessmentSealed,
    getAssessmentEndFinishData: state => state.assessmentEndFinishData
};


// ======================================================================
// Actions
// ======================================================================

const actions = {
    loadScoringData ({ commit, dispatch }) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/scoring');
            axiosRequest.then((response) => {
                if (typeof response.data.data !== "undefined") {
                    if (typeof response.data.data.SCORING !== "undefined") {

                        let scoringData = response.data.data.SCORING;
                        let decisionItems3 = [];
                        let decisionItems4 = [];
                        if (scoringData.decisions != null) {
                            decisionItems3 = scoringData.decisions.decisionItems3 || [];
                            decisionItems4 = scoringData.decisions.decisionItems4 || [];
                            // We separate each decisionItems3 and decisionItems4 array into 2 arrays
                            // decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible
                            const {decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible} = this._vm.$DecisionItemHelperPlugin.splitDecisionItems(decisionItems3, decisionItems4, 'mandatory');

                            // We add the 2 arrays to the scoringData.decisions object
                            scoringData.decisions['decisionItems3Recommended'] = decisionItems3Recommended;
                            scoringData.decisions['decisionItems3Possible'] = decisionItems3Possible;
                            scoringData.decisions['decisionItems4Recommended'] = decisionItems4Recommended;
                            scoringData.decisions['decisionItems4Possible'] = decisionItems4Possible;
                        }


                        commit('setScoringData', scoringData);
                    }
                    if (typeof response.data.data.ASSESSMENT_END_FINISH_BUTTON_DATA !== "undefined") {
                        commit('setAssessmentEndFinishData', response.data.data.ASSESSMENT_END_FINISH_BUTTON_DATA);
                    }
                    if (typeof response.data.data.ASSESSMENT_SEALED !== "undefined" && typeof response.data.data.ASSESSMENT_SEALED.sealed !== "undefined") {
                        commit('setIsAssessmentSealed', response.data.data.ASSESSMENT_SEALED.sealed);
                    }
                    if (typeof response.data.data.TEST_TREE !== "undefined") {
                        commit('setTestTreeData', response.data.data.TEST_TREE);
                    }
                    if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                        commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
                    }
                    if (typeof response.data.data.PATIENT_DATA !== "undefined") {
                        commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
                    }

                    if (typeof response.data.data.USER_DECISION !== "undefined") {
                        commit('setUserDecisionData', response.data.data.USER_DECISION);
                    }
                    if (typeof response.data.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
                        commit('AssessmentStartStore/setShortAnswersPreview', response.data.data.SHORT_ANSWERS_PREVIEW, {root: true});
                    }

                    if (typeof response.data.data.ASSESSMENT !== 'undefined') {
                        if (typeof response.data.data.ASSESSMENT.assessmentToken !== 'undefined') {
                            commit('AssessmentStartStore/setAssessmentToken', response.data.data.ASSESSMENT.assessmentToken, {root: true});
                        }
                        if (typeof response.data.data.ASSESSMENT.assessmentVersion !== 'undefined') {
                            commit('AssessmentStartStore/setAssessmentVersion', response.data.data.ASSESSMENT.assessmentVersion, {root: true});
                        }
                    }
                }

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                resolve(response);
            });
            axiosRequest.catch((error) => {
                reject(error);
            });
        });

        return promise;
    },

    submitUserDecisionComment ({getters}, data) {

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/saveUserDecisionComment', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save user decision comment.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    submitUserDecisionItem1 ({getters}, data) {

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/saveUserDecisionItem1', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save user decision item 1.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    submitUserDecisionItem2 ({getters}, data) {

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/saveUserDecisionItem2', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save user decision item 2.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitUserCodeSystemSelect ({getters}, data) {

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/saveUserCodeSystem', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save user code system.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    showSendAssessmentPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowSendAssessmentPopup', true);
        });

        return promise;
    },
    showPrintPdfPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowPrintPdfPopup', true);
        });

        return promise;
    },
    showSummaryPopup({ commit, dispatch}) {
        let promise = new Promise((resolve, reject) => {

            commit('setMustShowSummaryPopup', true);

            dispatch('SummaryStore/loadSummaryDataNew', {assessmentId: state.summaryAssessmentId}, {root:true}, );

        });

        return promise;
    }

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    // ----------- Scoring Data: -----------

    setScoringData (state, data) {
        state.scoringData = data;
    },
    clearScoringData (state) {
        state.scoringData = {};
    },


    // ----------- Test Tree Data: -----------

    setTestTreeData(state, data) {
        state.testTreeData = data;
    },
    clearTestTreeData(state) {
        state.testTreeData = '';
    },


    // ----------- My decision: -----------

    setUserDecisionData (state, data) {
        state.userDecision = data;
    },
    setAssessmentSent (state, data) {
        state.assessmentSent = data;
    },
    setMustShowSendAssessmentPopup (state, data) {
        state.mustShowSendAssessmentPopup = data;
    },
    setMustShowPrintPdfPopup (state, data) {
        state.mustShowPrintPdfPopup = data;
    },
    setMustShowSummaryPopup (state, data) {
        state.mustShowSummaryPopup = data;
    },
    setSummaryAssessmentId (state, data) {
        state.summaryAssessmentId = data;
    },
    setIsAssessmentSealed (state, newValue) {
        state.isAssessmentSealed = newValue;
    },

    setAssessmentEndFinishData (state, newValue) {
        state.assessmentEndFinishData = newValue;
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.scoringData                  = defaultState.scoringData;
        state.testTreeData                 = defaultState.testTreeData;

        state.userDecision                 = {
            decisionItem1List:              defaultState.userDecision.decisionItem1List,
            selectedDecisionItem1Code:      defaultState.userDecision.selectedDecisionItem1Code,
            decisionItem2List:              defaultState.userDecision.decisionItem2List,
            selectedDecisionItem2Code:      defaultState.userDecision.selectedDecisionItem2Code,
            comment:                        defaultState.userDecision.comment
        };
        state.mustShowSendAssessmentPopup = defaultState.mustShowSendAssessmentPopup,
        state.mustShowPrintPdfPopup       = defaultState.mustShowPrintPdfPopup,
        state.assessmentSent              = defaultState.assessmentSent,
        state.mustShowSummaryPopup        = defaultState.mustShowSummaryPopup,
        state.summaryAssessmentId         = defaultState.summaryAssessmentId,
        state.isAssessmentSealed          = defaultState.isAssessmentSealed,
        state.assessmentEndFinishData     = defaultState.assessmentEndFinishData
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/ScoringStore.js